<template>
  <AppCheckbox v-model="enabled" :hint="$tt('whatsapp_alerts_hint')">
    <template #label>
      {{ $tt('whatsapp_alerts_label') }}
      <AppIcon icon="mdi:whatsapp" color="success" end />
    </template>
  </AppCheckbox>
</template>

<script setup lang="ts">
const enabled = defineModel<boolean>({ required: true });
</script>